import { translate } from '../../../core';
import { useQuery } from '@apollo/client';
import { Col, Divider, Form, Input, InputNumber, Row } from 'antd';
import { Combo, enumToComboOptionTransformer, NumericInput, Section } from '../../../core/component';
import { Sex, WatchMovement, WatchShape } from '../type';
import styles from "./ItemForm.module.scss"
import { InputCard } from './InputCard';
import { WatchDialAutoComplete } from './WatchDialAutoComplete';
import { WatchLookupSelect } from './WatchLookupSelect';
import { GetWatchAttributeOptions } from '../graphql/item.graphql';

const WATCH_MOVEMENTS = Object.values(WatchMovement)
const WATCH_SHAPES = Object.values(WatchShape)

export const ItemFormWatch = () => {
  const { data } = useQuery(GetWatchAttributeOptions)

  return (
    <InputCard contained className='mt-4 bg-white' title={translate('watch')}>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Form.Item
            className={styles["types-first-input"]}
            label={translate('name')}
            name={['watch', 'name']}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col span={8}>
          <Form.Item
            className={styles["types-first-input"]}
            label={translate('lady', '/', 'gentleman')}
            name={['watch', 'type']}
          >
            <Combo
              size='middle'
              options={enumToComboOptionTransformer(Sex)}
            />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            label={translate('movement')}
            name={['watch', 'movement']}
          >
            <WatchLookupSelect
              predefined={WATCH_MOVEMENTS}
              persisted={data?.watchAttributeOptions.movements}
            />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            label={translate('shape')}
            name={['watch', 'shape']}
          >
            <WatchLookupSelect
              predefined={WATCH_SHAPES}
              persisted={data?.watchAttributeOptions.shapes}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col span={8}>
          <Form.Item
            className={styles["types-first-input"]}
            label={translate('dial')}
            name={['watch', 'dial']}
          >
            <WatchDialAutoComplete />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            label={translate('band')}
            name={['watch', 'band']}
          >
            <Input />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            label={translate('material')}
            name={['watch', 'material']}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Form.Item
            className={styles["types-first-input"]}
            label={translate('face_color')}
            name={['watch', 'forceColor']}
          >
            <Input />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            label={translate('case_color')}
            name={['watch', 'colorCase']}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col span={8}>
          <Form.Item
            className={styles["types-first-input"]}
            label={translate('case_number_abbr')}
            name={['watch', 'caseNumber']}
          >
            <Input />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            label={translate('serial_number_abbr')}
            name={['watch', 'serialNumber']}
          >
            <Input />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            label={translate('case_size', '(mm)')}
            name={['watch', 'caseSize']}
            rules={[
              {
                type: 'number',
                min: 1,
                message: translate('case_size', 'is_greater_than', '1'),
              }
            ]}
          >
            <NumericInput
              decimalPlaces={0}
            />
          </Form.Item>
        </Col>
      </Row>
    </InputCard>
  )
}
